module.exports = __webpack_public_path__ + "img/icon-login_duanxin.1c6283a6.svg";